import { Link } from "@tanstack/react-router";
import type { RelatedLink } from "@/lib/related-links";
import { trackEvent } from "@/lib/analytics";

function LinkGrid({
  links,
  eventContext,
}: {
  links: RelatedLink[];
  eventContext: Record<string, string | undefined>;
}) {
  return (
    <ul className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
      {links.map((l) => (
        <li key={l.href}>
          {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
          <Link
            to={l.href as any}
            className="block h-full rounded-lg border border-border bg-muted/30 px-3 py-2 transition-colors hover:border-primary/40 hover:bg-muted/60 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            onClick={() =>
              trackEvent("related_link_click", {
                action: "related_link_click",
                target_path: l.href,
                label: l.label,
                ...eventContext,
              })
            }
          >
            <span className="text-sm font-medium text-primary">{l.label}</span>
            {l.description && (
              <span className="mt-0.5 block text-xs text-muted-foreground">{l.description}</span>
            )}
          </Link>
        </li>
      ))}
    </ul>
  );
}

export function RelatedSections({
  games,
  states,
  gamesHeading = "Related lottery games",
  statesHeading = "Related states",
  gameSlug,
  stateSlug,
}: {
  games: RelatedLink[];
  states: RelatedLink[];
  gamesHeading?: string;
  statesHeading?: string;
  gameSlug?: string;
  stateSlug?: string;
}) {
  const ctx = { game_id: gameSlug, state_id: stateSlug };
  return (
    <>
      {games.length > 0 && (
        <section className="mt-10" aria-labelledby="related-games-heading">
          <h2 id="related-games-heading" className="font-sans text-[20px] font-bold mb-3 tracking-tight">
            {gamesHeading}
          </h2>
          <LinkGrid links={games} eventContext={ctx} />
        </section>
      )}
      {states.length > 0 && (
        <section className="mt-8" aria-labelledby="related-states-heading">
          <h2 id="related-states-heading" className="font-sans text-[20px] font-bold mb-3 tracking-tight">
            {statesHeading}
          </h2>
          <LinkGrid links={states} eventContext={ctx} />
          <p className="mt-3 text-sm">
            <Link to="/states" className="text-primary hover:underline">
              Browse all 50 state lottery hubs →
            </Link>
          </p>
        </section>
      )}
    </>
  );
}
